/** Node Modules */
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import React, { Suspense } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { ThemeProvider } from "@material-ui/core/styles";
import { PersistGate } from "redux-persist/integration/react";

/** Custom Modules */
import App from "./App";
import theme from "./theme";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./redux/store";

/** Styles */
import "./assets/style/general.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback="">
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </Suspense>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

reportWebVitals();
